import React from 'react';

import css from '../../FundingAccount.module.scss';

interface LinkProps {
  handleOnClick: () => void;
}

export default function MSPlaidLink({ handleOnClick }: LinkProps) {
  return (
    <div>
      <div
        className={`${css.AddFundingAccountUnselected} ${css.AddFundingAccountSecondary} ${css.AddFundingAccountContainer}`}
        onClick={handleOnClick}
        data-testid="ms-plaid-link"
      >
        <div className={css.ManualAchWrapper}>
          <div>
            <p
              data-testid="ms-plaid-link-text"
              className={css.AddFundingAccountItemHeader}
            >
              Add a bank instantly
            </p>
          </div>
          <div className={css.manualACHButton}>
            <svg
              width="6"
              height="10"
              viewBox="0 0 6 10"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1 1L5 5L1 9"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
        </div>
      </div>
    </div>
  );
}
